import styled from "styled-components";

export const breakpoints = {
  sm: '600px',
  md: '960px',
  lg: '1127px',
};

export const RewardOfferItemContent = styled.div`
  background: #fff;
  height: 104px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ImageStyled = styled.div`
  width: 80px;
  height: 80px;
  position: absolute;
  left: 10px;
  top: 50%;
  margin-top: -40px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
  }

  @media screen and (max-width: ${breakpoints.lg}) {
    width: 70px;
    height: 70px;
    margin-top: -35px;
  }

  @media screen and (max-width: ${breakpoints.md}) {
    width: 60px;
    height: 60px;
    margin-top: -30px;
  }
`;

export const InfoStyled = styled.div`
  width: 155px;
  span {
    display: block;
  }
  .top-title {
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  .bottom-title {
    font-weight: bold;
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 2px;
  }

  .bottom-title-detail {
    font-size: 8px;
  }

  .call-to-action {
    font-size: 10px;
    text-transform: uppercase;
    color: #95B040;
    font-weight: bold;
    letter-spacing: 0.03em;
    cursor: pointer;
    margin-top: 3px;
  }

  @media screen and (max-width: ${breakpoints.lg}) {
    width: 140px;
  }
`;

export const CircleButton = styled.div`
  position: absolute;
  top: 50%;
  margin-top: -15.5px;
  right: 43px;
  color: white;
  width: 31px;
  height: 31px;
  border-radius: 24.5px;
  background-color: white;
  text-align: center;
  padding-top: 8px;
  cursor: pointer;
  border: 1px solid black;
`;

export const CheckButton = styled(CircleButton)`
  padding-top: 5px;
  background-color: black;
  border: 1px solid #221F20;
`;

export const OfferCheckButton = styled(CircleButton)`
  background-color: #757575;
  padding-top: 7px;
`;

export const FlameContainer = styled.div<{ enableOpacity: boolean, color: string }>`
  position: absolute;
  right: 0;
  top: 0;
  width: 64px;
  height: 104px;
  opacity: ${p => (p.enableOpacity ? 0.5 : 1)};

  &:before {
    content:'';
    position:absolute;
    top:0; right:-30px;
    width:100%; height:100%;
    background-color: ${p => p.color};
    border-right:40px solid ${p => p.color};

    -webkit-transform-origin:100% 100%;
    -ms-transform-origin:100% 100%;
    transform-origin:100% 100%;

    -webkit-transform:skewX(-15deg);
    -ms-transform:skewX(-15deg);
    transform:skewX(-15deg);
  }
`;

export const FlameIconStyled = styled.div`
  position: relative;
  width: 64px;
  height: 104px;
  svg {
    width: 63px;
    height: 86px;
    position: absolute;
    bottom: 0;
    right: -10px;
  }
`;